import * as React from 'react';
import { createPortal } from 'react-dom';

import { useWebflowPoc } from '@/hooks/useWebflowPoc';
import { useWebflowUtilitiesSlotAnchor } from '@/lib/webflow-poc/useWebflowUtilitiesSlotAnchor';
import { WebflowUtilitiesOverlay } from '@/lib/webflow-poc/WebflowUtilitiesOverlay';

type WebflowNavAlignedUtilitiesProps = {
  /** Parent that contains the rendered Webflow nav HTML. */
  containerRef: React.RefObject<HTMLElement | null>;
  htmlKey: string | null | undefined;
};

/**
 * Aligns TW utilities to the configured Webflow mount element (id or class).
 * Portals to document.body so Webflow CSS isolation cannot break Chakra
 * menus/icons. No-ops unless Webflow is flag-on + integrated.
 */
export const WebflowNavAlignedUtilities: React.FC<
  WebflowNavAlignedUtilitiesProps
> = ({ containerRef, htmlKey }) => {
  const { isEnabled, utilitiesMount } = useWebflowPoc();

  const anchor = useWebflowUtilitiesSlotAnchor({
    containerRef,
    htmlKey,
    enabled: isEnabled,
    utilitiesMount,
  });

  if (!isEnabled || typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <WebflowUtilitiesOverlay
      anchor={anchor}
      dataAttribute="data-tradewing-nav-utilities"
    />,
    document.body
  );
};
